import { useState } from "react";
import "./tabswitch.css";
import dots from "../../assets/dots.svg";
import complianceOfficersImage from "../../assets/use-cases/SVG/compliance-officers.svg";
import riskManagersImage from "../../assets/use-cases/SVG/risk-managers.svg";
import auditTeamsImage from "../../assets/use-cases/SVG/audit-teams.svg";
import securityTeamsImage from "../../assets/use-cases/SVG/security-teams.svg";
import governanceSpecialistsImage from "../../assets/use-cases/SVG/governance-specialists.svg";
import legalTeamsImage from "../../assets/use-cases/SVG/legal-teams.svg";
import itGovernanceImage from "../../assets/use-cases/SVG/it-governance.svg";

const Tabswitch = () => {
  const [activeTab, setActiveTab] = useState("AI Policy");

  const tabs = [
    "AI Policy",
    "Risk Monitoring",
    "Compliance",
    "Vendor Oversight",
    "Explainability",
    "Data Governance",
    "Performance",
  ];

  const tabContent = {
    "AI Policy": {
      heading: "Govern AI Usage at Scale",
      paragraph:
        "Automate model risk classification, usage approvals, and policy enforcement across teams to maintain control over AI deployments. Ensure consistent governance standards and streamlined approval workflows for all AI initiatives.",
      image: complianceOfficersImage,
    },
    "Risk Monitoring": {
      heading: "Proactive Risk Detection",
      paragraph:
        "Continuously monitor for bias, drift, and performance issues with autonomous agents that surface real-time alerts and recommend mitigation. Stay ahead of potential AI risks before they impact business operations.",
      image: riskManagersImage,
    },
    Compliance: {
      heading: "Stay Aligned with Global Standards",
      paragraph:
        "Automate compliance workflows and reporting with built-in support for frameworks like the EU AI Act, NIST RMF, and ISO 42001. Ensure your AI systems meet regulatory requirements across multiple jurisdictions.",
      image: auditTeamsImage,
    },
    "Vendor Oversight": {
      heading: "Control Third-Party and Generative AI",
      paragraph:
        "Monitor third-party models and LLMs to detect misuse, prevent hallucinations, and ensure governance beyond internal systems. Maintain visibility and control over external AI services and integrations.",
      image: securityTeamsImage,
    },
    Explainability: {
      heading: "Make AI Decisions Transparent",
      paragraph:
        "Deliver human-readable explanations of model behaviour using tools like SHAP and LIME to support internal reviews and external audits. Build trust through transparent AI decision-making processes.",
      image: governanceSpecialistsImage,
    },
    "Data Governance": {
      heading: "Secure AI Data Pipelines",
      paragraph:
        "Implement comprehensive data lineage tracking and privacy controls to ensure AI models comply with data protection regulations like GDPR and CCPA. Monitor data usage patterns and maintain audit trails for all AI data flows.",
      image: legalTeamsImage,
    },
    Performance: {
      heading: "Optimize AI Operations & Costs",
      paragraph:
        "Continuously monitor and optimize AI model performance, resource utilization, and operational costs. Implement automated scaling policies and identify opportunities for model consolidation to maximize ROI.",
      image: itGovernanceImage,
    },
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <section className="grid-card-section" id="three">
      <div className="container">
        <div className="grid-card-heading">
          <div className="section-tag">
            <img src={dots} alt="dots" />
            <p>Use Cases</p>
          </div>
          <h2 className="grid-card-title">
            Operationalizing AI Governance Across the Enterprise
          </h2>
          <p className="grid-card-subtext">
            AgentGRC.ai brings a paradigm shift to Governance, Risk, and
            Compliance by integrating AI agents that work continuously to
            identify gaps, flag risks, and ensure policy adherence.
          </p>
        </div>

        <div className="tabs-container">
          <div className="tabs">
            {tabs.map((tab) => (
              <div
                key={tab}
                className={`tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </div>
            ))}
          </div>

          <div className="tab-content row">
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 right-content">
              <div className="content-heading">
                <h3>{tabContent[activeTab]?.heading}</h3>
              </div>
              <p>{tabContent[activeTab]?.paragraph}</p>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 content-image">
              <img
                src={tabContent[activeTab]?.image}
                alt={activeTab}
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tabswitch;
